/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generating_LabelInputs */



/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Image_Export_Preview_Generating_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generating_label = /** @type {((inputs?: Image_Export_Preview_Generating_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generating_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird generiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("生成中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जनरेट हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando...")
	return /** @type {LocalizedString} */ ("Generating...")
});